module.exports = __webpack_public_path__ + "lit-up.884aa2f4e787d2938921.gif";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/images/lit-up.gif
// module id = ../../../../../src/assets/images/lit-up.gif
// module chunks = 2